import type { EditableDigitalChannel } from "../../../../config"

export const templateFields = (channel: EditableDigitalChannel) =>
  channel === "email" ? ["subject", "body"] : channel === "phone" ? ["opening"] : ["body"]

export const readDigitalTemplate = (
  policy: OrganizationContactPolicy,
  channel: EditableDigitalChannel,
  purpose: string,
  defaults = false,
): Record<string, string> | null => {
  const source = defaults ? policy.default_templates : policy.templates
  const templates = source[channel] as Record<string, Record<string, unknown>> | undefined
  const values = templates?.[purpose]

  if (!values || typeof values !== "object") return null

  return Object.fromEntries(
    templateFields(channel).map((field) => [field, String(values[field] ?? "")]),
  )
}

export const digitalTemplateHelp = {
  email: { title: "E-Mail-Vorlagen", helpId: "planningEmailTemplates" },
  sms: { title: "SMS-Vorlagen", helpId: "planningSmsTemplates" },
  phone: { title: "Telefonvorlagen", helpId: "planningPhoneTemplates" },
} as const
